module.exports = __webpack_public_path__ + "static/media/cookie_header.58bf934f.png";